<template>
  <HomepageFeatureSection
    title="Financial answers on demand"
    body="Your own personal finance tutor. Ask Era AI about the news, your money, and anything in between."
    color="var(--colorSwissPurple300)"
  >
    <div class="HomepageChatFeatureSection__messageList">
      <ThreadMessage
        v-for="message in messages"
        :key="message.IdReference"
        class="HomepageChatFeatureSection__message"
        :modelValue="message"
      />
    </div>
  </HomepageFeatureSection>
</template>

<script lang="ts" setup>
import HomepageFeatureSection from "@cosine/components/homepage/HomepageFeatureSection.vue";
import ThreadMessage from "@cosine/components/ThreadMessage.vue";
import { createThreadMessage } from "@cosine/tests/factories/ThreadFactory";
import { IClientThreadEntry } from "@cosine/types/api-models";
import { ref } from "vue";

const messages = ref<Array<IClientThreadEntry>>([
  createThreadMessage({
    Text: "what’s the difference between a roth ira and a traditional ira?",
    Source: "User",
  }),
  createThreadMessage({
    Text: "what’s a tax deduction?",
    Source: "User",
  }),
  createThreadMessage({
    Text: "what’s the latest with AAPL and NVDA?",
    Source: "User",
  }),
  createThreadMessage({
    Text: "how much should i be saving for retirement?",
    Source: "User",
  }),
]);
</script>

<style lang="scss" scoped>
.HomepageChatFeatureSection__messageList {
  display: flex;
  flex-direction: column;
  gap: 8px 0;
  align-items: flex-start;
}

.HomepageChatFeatureSection__message {
  margin: 0;

  &:first-child {
    align-self: flex-start;
    width: 240px;
  }

  &:nth-child(2) {
    align-self: flex-end;
    margin-right: 72px;
  }

  &:nth-child(3) {
    align-self: flex-end;
    width: 178px;
  }

  &:last-child {
    align-self: flex-start;
    width: 230px;
    margin-left: 56px;
  }
}
</style>
